export const DEFAULT_BOILERPLATE_CODES = {
  python: `# Hello World Program
print("Hello World")`,
  javascript: `// Hello World Program
console.log("Hello World");`,
  java: `public class HelloWorld {
    public static void main(String[] args) {
        System.out.println("Hello World");
    }
}`,
  go: `package main

import "fmt"

func main() {
    fmt.Println("Hello World")
}`,
  cpp: `#include <iostream>
using namespace std;

int main() {
    cout << "Hello World" << endl;
    return 0;
}`,
  c: `#include <stdio.h>

int main() {
    printf("Hello World\\n");
    return 0;
}`,
};
